<div class="pages-body animated fadeIn fast">
  <app-header></app-header>
  <mat-drawer-container class="mat-container" autosize>
    <mat-drawer #drawer [opened]="opened" class="sidenav" mode="side">
      <div
        class="button-container"
        *ngIf="_auth.user.isAdmin() || _auth.user.isExecutive()"
      >
        <div class="button-sidenav" (click)="touch()">
          <button class="button-menu button-left-menu btn btn-circle">
            <img src="assets/images/left-menu/icn-management.png" />
          </button>
          <p
            *ngIf="showFiller"
            class="d-initial item animated fadeIn slow"
            [routerLink]="_auth.user.getUserManagementUrl()"
          >
            {{ constants.permissions.userManagement.label }}
          </p>
        </div>
      </div>
      <div
        class="button-container"
        *ngIf="
          _auth.user.hasPermission(constants.permissions.createRequest.id) ||
          _auth.user.hasPermission(constants.permissions.getRequests.id)
        "
      >
        <div
          class="button-sidenav"
          (click)="touch()"
          data-toggle="collapse"
          data-target="#demo2"
        >
          <button class="button-menu button-left-menu btn btn-circle">
            <img src="assets/images/left-menu/icn-summary.png" />
          </button>
          <p *ngIf="showFiller" class="d-initial item animated fadeIn slow">
            Solicitudes
          </p>
          <img
            class="sidenav-arrow"
            src="assets/images/left-menu/icon-arrow.png"
          />
        </div>
        <div id="demo2" class="collapse" name="listDiv">
          <ul class="list-group">
            <li
              class="list-group-item animated fadeIn"
              *ngIf="
                _auth.user.hasPermission(constants.permissions.createRequest.id)
              "
            >
              <a
                [routerLink]="['/pages/new-request']"
                class="sub-item"
                href=""
                >{{ constants.permissions.createRequest.label }}</a
              >
            </li>
            <li
              class="list-group-item animated fadeIn"
              *ngIf="
                _auth.user.hasPermission(constants.permissions.getRequests.id)
              "
            >
            
              <a
                [routerLink]="['/pages/request-search']"
                class="sub-item"
                href=""
                >{{ constants.permissions.getRequests.label }}</a
              >
            </li>
          </ul>
        </div>
      </div>
    </mat-drawer>

    <div class="example-sidenav-content" (click)="clickout()">
      <div class="content">
        <!-- <button type="button" mat-button (click)="drawer.toggle()">
          Toggle sidenav
        </button> -->
        <router-outlet></router-outlet>
      </div>
    </div>
  </mat-drawer-container>
  <!-- <app-left-menu></app-left-menu> -->
</div>
<app-footer></app-footer>
<!-- RECEIPT MODAL -->
<app-receipt-modal></app-receipt-modal>
